import React, { useEffect, useState } from "react"
import AddExpensePage from "../../../../entities/DashboardPage/AccountingModule/AddExpensePage"
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";

const AddExpense = () => {
  const [banks, setBanks] = useState();
  const [types, setTypes] = useState()
  const [loading, setLoading] = useState(false)
  const {showAlert} = useAlert()
  const navigate = useNavigate();

  useEffect(() => {
    getAllBanks()
    getExpenseType("Expense")
  },[])
  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllBanks();
      if (result?.success) {
        setBanks(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getExpenseType = async (type) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getExpenseType(type);
      if (result?.success) {
        setTypes(result?.data?.types);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const createExpense = async (data,type,date,paymentMode,bankDetails) => {
    setLoading(true);
    try {
      const result = await AuthService.createExpense(data,type,date,paymentMode,bankDetails);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/expense")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  return(
    <>
      <AddExpensePage banks={banks} createExpense={createExpense} loading={loading} types={types}/>
    </>
  )
}

export default AddExpense